/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DinamicoAliases {
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_0 = 'fetch-0',
  FETCH_1 = 'fetch-1',
  HPMS_DYNAMIC_SCREEN_0 = 'hpms-dynamic-screen-0',
  LAYOUT_DINAMICO = 'layout-dinamico',
  PANEL_0 = 'panel-0',
}
export { DinamicoAliases };
